import { toCameraLocalDateTime } from "./cameraLocalDateTime";

export type MediaDuplicateFingerprint = {
  filename: string;
  originalSize: number;
  takenAt?: string | null;
};

export function normalizeDuplicateFilename(filename: string): string {
  return filename.normalize("NFC");
}

export function duplicateNameSizeKey(filename: string, originalSize: number): string {
  return `${normalizeDuplicateFilename(filename)}\0${originalSize}`;
}

export function sameMediaTakenAt(left?: string | null, right?: string | null): boolean {
  return toCameraLocalDateTime(left) === toCameraLocalDateTime(right);
}

/**
 * Album duplicates: same original filename, byte size, and capture time.
 * Missing capture time matches another missing capture time (screenshots, etc.).
 */
export function isMediaDuplicate(incoming: MediaDuplicateFingerprint, existing: MediaDuplicateFingerprint): boolean {
  if (normalizeDuplicateFilename(incoming.filename) !== normalizeDuplicateFilename(existing.filename)) {
    return false;
  }
  if (incoming.originalSize !== existing.originalSize) {
    return false;
  }
  return sameMediaTakenAt(incoming.takenAt, existing.takenAt);
}
